import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const vegaLevelsGetter = function (PineJS) {
 return Promise.resolve([
   {
     name: 'SPX Vanna Levels',
     metainfo: {
       metainfoVersion: 53,
       id: "SPX Vanna Levels@tv-basicstudies-1",
       description: "SPX Vanna Levels",
       shortDescription: "SPX Vanna Levels",
       format: { type: "price" },
       linkedToSeries: true,
       is_price_study: true,
       plots: [
         { id: "call_r1", type: "line" },
         { id: "call_r2", type: "line" },
         { id: "put_r1",  type: "line" },
         { id: "put_r2",  type: "line" }
       ],
       defaults: {
         styles: {
           call_r1: {
             linestyle: 0,
             linewidth: 1,
             transparency: 0,
             color: "#FFD700", // Gold
           },
           call_r2: {
             linestyle: 1,
             linewidth: 1,
             transparency: 0,
             color: "#FFD700",
           },
           put_r1: {
             linestyle: 0,
             linewidth: 1,
             transparency: 0,
             color: "#4169E1", // Royal Blue
           },
           put_r2: {
             linestyle: 1,
             linewidth: 1,
             transparency: 0,
             color: "#4169E1",
           },
         },
       },
       styles: {
         call_r1: { title: "Vanna Call R1" },
         call_r2: { title: "Vanna Call R2" },
         put_r1:  { title: "Vanna Put R1" },
         put_r2:  { title: "Vanna Put R2" },
       },
       inputs: [],
     },
     constructor: function () {
       this._debugMode = true;

       this.init = function (ctx) {
         this._context = ctx;
       };

       this.main = function (ctx) {
         try {
           const { topOptions } = useGreeksWebsocketDataStore.getState();
           const spxOptions = topOptions.spx;

           // If we don't have options data, return NaNs
           if (!spxOptions?.length) {
             if (this._debugMode) {
               // console.log('[vegaLevelsGetter] No top options data');
             }
             return [NaN, NaN, NaN, NaN];
           }

           // Filter to only "vega" options
           const vegaOptions = spxOptions.filter(opt => opt.greek_type === 'vega');

           const callR1 = vegaOptions.find(opt => opt.option_type === 'call' && opt.rank === 1)?.strike_price || NaN;
           const callR2 = vegaOptions.find(opt => opt.option_type === 'call' && opt.rank === 2)?.strike_price || NaN;
           const putR1 = vegaOptions.find(opt => opt.option_type === 'put' && opt.rank === 1)?.strike_price || NaN;
           const putR2 = vegaOptions.find(opt => opt.option_type === 'put' && opt.rank === 2)?.strike_price || NaN;

           // if (this._debugMode) {
           //   console.log('[vegaLevelsGetter] Levels:', {
           //     callR1,
           //     callR2,
           //     putR1,
           //     putR2,
           //     optionsCount: vegaOptions.length
           //   });
           // }

           // Return the same level for any point in time
           return [callR1, callR2, putR1, putR2];
         } catch (err) {
           console.error('[vegaLevelsGetter] Error in main:', err);
           return [NaN, NaN, NaN, NaN];
         }
       };

       this.destroy = function() {
         // No cleanup needed since we're not using subscriptions
       };
     },
   },
 ]);
};
